import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';

export const FormGroup = ({title, initiallyVisible, children}) => {
    const wrapper = useRef(null);
    const [visible, setVisible] = useState(initiallyVisible);

    const toggleWrapper = () => {
        wrapper.current.classList.toggle('tw-hidden');
        setVisible(!visible);
    };

    return (
        <div>
            <div className="tw-mb-0 tw-mt-0 dark:tw-text-white">
                <button
                    className="tw-mb-[1px] tw-flex tw-w-full tw-items-center tw-justify-between tw-border-none tw-bg-lightBlue tw-bg-none tw-px-2.5 tw-py-3 tw-text-left tw-font-sans tw-font-medium tw-text-darkBlue hover:tw-underline dark:tw-text-white"
                    onClick={toggleWrapper}
                >
                    {title}
                    {visible ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path
                                stroke="currentColor"
                                strokeWidth="2px"
                                fillRule="evenodd"
                                d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                            />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path
                                stroke="currentColor"
                                strokeWidth="2px"
                                fillRule="evenodd"
                                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                            />
                        </svg>
                    )}
                </button>
            </div>
            <div className={`tw-my-4 tw-pl-2 ${!initiallyVisible ? 'tw-hidden' : ''}`} ref={wrapper}>
                {children}
            </div>
        </div>
    );
};

FormGroup.propTypes = {
    title: PropTypes.string,
    initiallyVisible: PropTypes.bool,
    children: PropTypes.node,
};
